import { Box, BoxProps } from '@chakra-ui/react';

interface IMark extends BoxProps {
  colorScheme?: string;
}

const Mark = (props: IMark) => {
  const { children, colorScheme = 'yellow' } = props;

  return (
    <Box
      as="mark"
      color={'chakra-body-text'}
      bgColor={`${colorScheme}.100`}
      _dark={{ bgColor: `${colorScheme}.800` }}
      {...props}
    >
      {children}
    </Box>
  );
};

export { Mark };
